/**
 * Die drei Zustände jeder Liste: lädt, leer, gescheitert.
 *
 * Sie werden hier einmal gebaut, damit sie überall gleich aussehen — und
 * damit „leer" nie wie „lädt noch" aussieht. Eine Belegliste, die
 * fälschlich leer wirkt, ist der Anfang einer doppelten Erfassung.
 */
import type { ReactNode } from 'react';
import { Fehlermeldung } from './Meldung';

export function Laedt({ was = 'Wird geladen' }: { was?: string }): ReactNode {
  return <div className="laedt">{was} …</div>;
}

export function Leer({
  titel,
  hinweis,
}: {
  titel: string;
  hinweis?: string | undefined;
}): ReactNode {
  return (
    <div className="leer">
      <strong>{titel}</strong>
      {hinweis ? <span className="klein">{hinweis}</span> : null}
    </div>
  );
}

/**
 * Hülle für eine geladene Liste.
 *
 * Reihenfolge der Prüfungen: Fehler zuerst — ein Fehler mit anschließend
 * leerer Liste darf nicht als „nichts vorhanden" durchgehen.
 */
export function Bereich<T>({
  abruf,
  leerTitel,
  leerHinweis,
  zeichne,
}: {
  abruf: { daten: T | null; laedt: boolean; fehler: string | null };
  leerTitel?: string | undefined;
  leerHinweis?: string | undefined;
  /** Wird nur mit geladenen Daten aufgerufen — kein `daten!` an der Aufrufstelle. */
  zeichne: (daten: T) => ReactNode;
}): ReactNode {
  if (abruf.fehler) return <div className="karte-koerper"><Fehlermeldung text={abruf.fehler} /></div>;
  if (abruf.laedt && abruf.daten === null) return <Laedt />;
  if (abruf.daten === null) {
    return <Leer titel={leerTitel ?? 'Keine Daten'} hinweis={leerHinweis} />;
  }
  return <>{zeichne(abruf.daten)}</>;
}
